import { useLocation } from "react-router-dom";
import * as CryptoJS from "crypto-js";
import { IBuscaquedaCasosTareas, IPayloadBuscaquedaCasosTareas } from "../../interfaces/backendApi/busquedaCasosTareas";

export const paramData = () => {
  let data: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);
  if (query.has("data")) {
    data = query.get("data") ? query.get("data") : null;
  }
  return data;
};

export const paramId = () => {
  let idTask: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);

  if (query.has("id")) {
    idTask = query.get("id") ? query.get("id") : null;
  }
  return idTask;
};

export interface ParametrosSearch {
  Tipo: number | null;
  ComienzoIdentificador: number | null;
  Leyenda: string | null;
}
export const useParamSearch = (): ParametrosSearch => {
  const query = new URLSearchParams(useLocation().search);

  return {
    Tipo: query.has("Tipo") ? Number(query.get("Tipo")) : null,
    ComienzoIdentificador: query.has("ComienzoIdentificador")
      ? Number(query.get("ComienzoIdentificador"))
      : null,
    Leyenda: query.get("Leyenda"),
  };
};


export const paramCasoActivo = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks  
  const location = useLocation();
  const esCasoArchivado =
    location.pathname === "/caso-detalle";
  return esCasoArchivado;
};

export const paramTarea = () => {
  let idTask: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);

  if (query.has("tarea")) {
    idTask = query.get("tarea") ? query.get("tarea") : null;
  }

  return idTask;
};
export const paramCaseId = () => {
  let idCase: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);

  if (query.has("caso")) {
    idCase = query.get("caso") ? query.get("caso") : null;
  }

  return idCase;
};
export const paramEstado = () => {
  let estado: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);

  if (query.has("estado")) {
    estado = query.get("estado") ? query.get("estado") : null;
  }

  return estado;
};

export const paramCaso = () => {
  let idCase: any;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const query = new URLSearchParams(useLocation().search);

  if (query.has("caso")) {
    idCase = query.get("caso") ? query.get("caso") : null;
  }

  return idCase;
};
